var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat2WHair5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "w-hair5_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M486.5,46.1c-4.2-1.6-8.5-3.1-12.7-4.5c-6.4-2-12.9-3.8-19.4-5.3s-13-3-19.4-4.4 c-44.4-7.5-88.4-7.5-132.5,0.6c-5.7,1.1-11.3,2.3-16.8,3.7c-51.1,13.1-104.1,44.1-123.5,95.6c-1.7,4.5-3,9.2-4,13.8 c-4,18.6-2.2,37.7,8.3,54.1c0,0.3,0,0.7,0.1,1c19.9,26.2,47.9,46.6,80.4,54.3c0.2-0.1,0.4-0.2,0.6-0.3 c-22.9-25.2-26.6-60.2-14.1-82h0.1c28.1-9.3,60.3-16.1,106-20l87.5,2.5c18.5-0.4,33,3.2,44.6,9.1l-9.1,6.4 c32.7,16.2,46.8,58.7,35.5,96c6.1-6.6,14-16.9,20.9-28.1c9.6-11.4,21.5-29,27-42.9c1.9-4.8,3.5-9.6,4.9-14.6 C569.5,128.5,541.5,63.5,486.5,46.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hats_w-hair5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m-hat2_5_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9C29B",
    d: "M514.1,175.6c3.8-4.2,18.7-18,12.4-22.2c-92.2-16.1-187.5-19.4-281-7.2c-12.3,1.6-24.6,3.4-36.9,5.5 c-7,1.3-13.9,2.8-20.8,4.4c-1.6,4.1,4.6,11.2,6.8,13.9c4.2,5,8.5,10.2,13.3,14.7c5.3,5,11.9,9.3,18.3,9.3 c85.1-19.9,175.6-19,262.5-3.5C500,189.9,507.2,183.3,514.1,175.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3A77C",
    d: "M235.1,147.5c-8.8,1.2-17.7,2.6-26.4,4.1c-7,1.3-13.9,2.8-20.8,4.4c-1.6,4.1,4.6,11.2,6.8,13.9 c4.2,5,8.5,10.2,13.3,14.7c5.3,5,11.9,9.3,18.3,9.3c30.9-7.2,62.5-11.7,94.3-13.7C289.4,175.4,257.5,167.5,235.1,147.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E9C29B",
    d: "M241.1,61.1c-9.4,25.3-16.1,60.4-16.9,88c7.1-1.1,14.2-2.1,21.4-3c81.5-10.6,164.3-9.5,245.3,1.7 c-2.7-32.4-8.2-64.4-19-94.4C411,36.7,311,30.9,241.1,61.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3A77C",
    d: "M241.1,61.1c-7.6,20.4-13.4,47.2-15.8,71.3c11-2.3,22.3-4.3,33.8-6c0.1-24.9,4.2-53.9,10.1-75.1 C259.4,54,250,57.2,241.1,61.1z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A110C",
    d: "M225.3,132.3c-0.6,5.8-1,11.4-1.1,16.8c7.1-1.1,14.2-2.1,21.4-3c81.5-10.6,164.3-9.5,245.3,1.7 c-0.4-5.1-0.9-10.2-1.5-15.3C409.2,114.5,308.7,114.8,225.3,132.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#947D70",
    d: "M443.4,124.4c-7.8-1-15.8-1.9-23.8-2.6l0.9,18.9c8,0.5,16,1.1,24,1.8L443.4,124.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat2WHair5);
export default __webpack_public_path__ + "static/media/m-hat2_w-hair5.ce16258bc1f43c92ad8d42db22f15b80.svg";
export { ForwardRef as ReactComponent };